module.exports = __webpack_public_path__ + "img/phone.6d7efe5f.svg";